module.exports = __webpack_public_path__ + "static/the-weather-makers-f332a5e0269a70867dbf114ce8ad8355.jpg";